import { Role } from "../../enum/auth";
import { IAuthActions } from "../actions/auth.action";

export interface IAuthState {
  email?: string;
  token?: string;
  userId?: string;
  expires?: string;
  role?: Role;
  login: {
    isLoading: boolean;
    error?: string;
  };
  signUp: {
    isLoading: boolean;
    otpRequestId?: string;
    otpExpiration?: string;
    error?: string;
  };
  forgotPassword: {
    isLoading: boolean;
    otpRequestId?: string;
    otpExpiration?: string;
    error?: string;
  };
}

const initialState: IAuthState = {
  login: {
    isLoading: false,
  },
  signUp: {
    isLoading: false,
  },
  forgotPassword: {
    isLoading: false,
  },
  userId: localStorage.getItem("userId") ?? undefined,
  expires: localStorage.getItem("expires") ?? undefined,
  role: (localStorage.getItem("role") as Role) ?? undefined,
  token: localStorage.getItem("token") ?? undefined,
};

export const authReducer = (
  state = initialState,
  action: IAuthActions,
): IAuthState => {
  switch (action.type) {
    case "AUTH_SIGNUP":
      return {
        ...state,
        signUp: {
          isLoading: true,
          error: undefined,
          otpRequestId: undefined,
          otpExpiration: undefined,
        },
      };
    case "AUTH_LOGIN":
      return {
        ...state,
        login: {
          isLoading: true,
          error: undefined,
        },
      };
    case "AUTH_FORGOT_PASSWORD_UPDATE":
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          isLoading: true,
          error: undefined,
        },
      };
    case "AUTH_FORGOT_PASSWORD_FAILURE":
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          isLoading: false,
          error: action.payload.error,
        },
      };
    case "AUTH_FORGOT_PASSWORD":
      return {
        ...state,
        forgotPassword: {
          ...state.forgotPassword,
          isLoading: true,
          error: undefined,
        },
      };
    case "AUTH_FORGOT_PASSWORD_SUCCESS":
      return {
        ...state,
        forgotPassword: {
          ...state.signUp,
          isLoading: false,
        },
        userId: action.payload.userId,
      };
    case "AUTH_SIGNUP_RESET":
      return {
        ...state,
        userId: undefined,
        signUp: {
          ...state.signUp,
          isLoading: false,
          error: undefined,
        },
      };
    case "AUTH_LOGIN_SUCCESS":
      return {
        ...state,
        login: {
          ...state.login,
          isLoading: false,
          error: undefined,
        },
        ...action.payload,
      };
    case "AUTH_LOGIN_FAILURE":
      return {
        ...state,
        login: {
          ...state.login,
          isLoading: false,
          error: action.payload.error,
        },
        token: undefined,
        expires: undefined,
        role: undefined,
      };
    case "AUTH_LOGOUT":
      return {
        ...state,
        expires: undefined,
        role: undefined,
        token: undefined,
        userId: undefined,
      };
    case "AUTH_SET_EMAIL":
      return {
        ...state,
        email: action.payload.email,
      };
    case "AUTH_SIGNUP_SUCCESS":
      return {
        ...state,
        signUp: {
          ...state.signUp,
          isLoading: false,
        },
        userId: action.payload.userId,
      };
    case "AUTH_SIGNUP_FAILURE":
      return {
        ...state,
        signUp: {
          ...state.signUp,
          isLoading: false,
          error: action.payload.error,
        },
      };
    default:
      return state;
  }
};
